import {
  BedrockRuntimeClient,
  InvokeModelCommand,
} from '@aws-sdk/client-bedrock-runtime';

const bedrockClient = new BedrockRuntimeClient({
  region: process.env.REACT_APP_AWS_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    sessionToken: process.env.REACT_APP_AWS_SESSION_TOKEN,
  },
});

// Function to call Amazon Bedrock Model using Messages API
export const invokeBedrockModel = async (productDescription) => {
  const prompt = `\n\nHuman: Generate a categorized list of technical keywords for a product description about "${productDescription}". Return the response STRICTLY in JSON format with these keys: 'materials', 'processes', 'standards', 'specifications', 'applications', 'location'. For each key, provide 4-5 keywords relevant to manufacturing. Rules:
    - **Materials**: Raw materials (e.g., medical-grade plastics).
    - **Processes**: Production methods (e.g., injection molding).
    - **Standards**: Compliance certifications (e.g., ISO 13485).
    - **Specifications**: Technical details (e.g., volume accuracy).
    - **Applications**: Use cases (e.g., medical injections).
    - **Location**: Manufactured In (e.g., India).
    DO NOT INCLUDE EXPLANATIONS—only the JSON object.

    \n\nAssistant:`;

  const input = {
    modelId: 'anthropic.claude-3-5-sonnet-20240620-v1:0',
    contentType: 'application/json',
    accept: 'application/json',
    body: JSON.stringify({
      anthropic_version: 'bedrock-2023-05-31',
      messages: [
        {
          role: 'user',
          content: prompt,
        },
      ],
      max_tokens: 1000,
    }),
  };

  try {
    const command = new InvokeModelCommand(input);
    const response = await bedrockClient.send(command);
    const responseBody = await response.body.transformToString();

    return JSON.parse(responseBody); // This should be a JSON object
  } catch (error) {
    console.error('Error invoking Amazon Bedrock:', error);
    throw new error();
  }
};
